// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"a1023235768299b2","6831":"2d268c83c2623ab3","8503":"195ecdf21201aefd","9683":"ddd42964aae8fe2e"}[chunkId] + ".js";
};